import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { NavButton } from 'components/Button'

type Props = {
  iconPath: string
  firstLabel: string
  secondLabel: string
  backToTop: () => void
}

const ShopCompleteTemplate: FC<Props> = (props) => {
  const { iconPath, firstLabel, secondLabel, backToTop } = props

  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={iconPath} alt={firstLabel + secondLabel} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          {firstLabel}
          <br />
          {secondLabel}
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} onClick={backToTop} url={''} />
      <Spacer size={72} />
    </div>
  )
}

export default ShopCompleteTemplate
